import { Container, Woman, Bubble, Dot } from './index.style'

const Banner = () => (
  <Container>
    <Woman>
      <Bubble>
        <Dot />
        <Dot />
        <Dot />
      </Bubble>
    </Woman>
  </Container>
)

export default Banner
